export default __webpack_public_path__ + "static/media/normal-size.9ade374c.svg";